import {api} from 'services/api';
import {Color} from 'types/colors';
import {ObjectId} from 'types/object-id';
import {ResponseData} from 'types/response-data';

const storeWebColor = api.injectEndpoints({
  endpoints: builder => ({
    storeWebColor: builder.mutation<Response, StoreColorRequest>({
      query: params => {
        return {
          method: 'POST',
          url: `color-webs`,
          body: {
            name: {
              en: params.name.en,
              fr: params.name.fr,
            },
            code: params.code,
          },
        };
      },
    }),
  }),
});

export type StoreColorRequest = {
  id?: ObjectId;
  name: {en: string; fr: string};
  code: any;
};

type Response = ResponseData<Color>;

export const {useStoreWebColorMutation} = storeWebColor;
